export const getIsConnected = (connectionStatus) =>
  ['connected', 'online'].includes(connectionStatus?.toLowerCase());

// disabled, offline, no_internet, online are the possible status from BE
const altBackupPortIcons = {
  disabled: 'port-deactivated-down',
  offline: 'port-unlinked-down',
  no_internet: 'port-no-internet-down',
  online: 'port-linked-down',
};

export const getAltBackupPortIcons = (connection) => {
  return (
    altBackupPortIcons[connection.toLowerCase().replace(' ', '_')] ||
    'port-linked-down'
  );
};
